/**
 * Created by abdulah.hamzic@thebeaverhead.com on 31/10/2018.
 */
import { isAppleDevice } from "./apps/calendar/helpers";

/**
 *
 * @type {*[]}
 */
export const PAYOUTS_EXPENSES_KINDS = [
  {
    label: "One time",
    value: "",
  },
  {
    label: "Monthly",
    value: "monthly",
  },
  {
    label: "Yearly",
    value: "yearly",
  },
];

/**
 *
 * @type {*[]}
 */
export const PAYOUTS_VENDORS = [
  {
    label: "Choose Vendor",
    value: "",
  },
  {
    label: "Fluid Ministry, LLC",
    value: "FLI",
  },
  {
    label: "The Beaverhead LTD",
    value: "TBH",
  },
];

/**
 *
 * @type {{cardList: string, detailedList: string, eventList: string, monthly: string, weekly: string, card: string, cardSlider: string}}
 */
export const CT = {
  eventList: "events_list",
  monthly: "monthly_view",
  weekly: "weekly_view",
  card: "card_view",
  cardList: "card_list",
  cardSlider: "card_slider",
  detailedList: "detailed_list",
  bubble: "bubble",
};

export const CT_NAMES = {
  [CT.eventList]: "Events List",
  [CT.monthly]: "Monthly View",
  [CT.weekly]: "Weekly View",
  [CT.card]: "Cards (grid)",
  [CT.cardList]: "Cards (list)",
  [CT.cardSlider]: "Cards (slider)",
  [CT.detailedList]: "Detailed List",
  [CT.bubble]: "Tiles",
};

/**
 * Group Widget Type GT
 * @type {{card: string}}
 */
export const GT = {
  card: "card_view",
  twoColumn: "two_col",
  outlined: "outlined",
  mosaic: "mosaic",
};
export const AT = {
  banner: "banner",
  modal: "modal",
  alert: "alert",
  takeover: "takeover",
  slider: "slider",
};
export const ST = {
  cardGrid: "cards",
  cardList: "cards_list",
};

/**
 * Preview Types PT
 * @type {{auto: string, desktop: string, mobile: string}}
 */
export const PT = {
  auto: "auto",
  desktop: "desktop",
  mobile: "mobile",
};

/**
 *
 * @type {{ccb: string, google: string, outlook: string}}
 */
export const IT = {
  google: "google",
  outlook: "outlook",
};

export const INTEGRATION_NAMES = {
  [IT.google]: "Google Calendar",
  [IT.outlook]: "Outlook Calendar™",
};

export const INTEGRATION_SHORT_NAMES = {
  [IT.google]: "Google",
  [IT.outlook]: "Outlook™",
};

export const INTEGRATION_AUTH_NAMES = {
  [IT.google]: "Google",
  [IT.outlook]: "Microsoft",
};

// Which brand button ProviderSignInButton renders for a given integration
// type. No fallback: a provider missing here should throw in
// ProviderSignInButton (PROVIDERS[undefined]) rather than silently show the
// wrong brand's sign-in button once a third provider is added.
export const SIGN_IN_PROVIDER = {
  [IT.google]: "google",
  [IT.outlook]: "microsoft",
};

/**
 * What one synced unit is called for a given integration type, e.g. "3
 * calendars synced". Defaults to "item" for any type not listed here, so
 * future non-calendar integrations don't inherit calendar-specific copy.
 * @type {{google: string, outlook: string}}
 */
export const INTEGRATION_ITEM_NAMES = {
  [IT.google]: "calendar",
  [IT.outlook]: "calendar",
};

export const DEFAULT_INTEGRATION_ITEM_NAME = "item";
/**
 * Plan Types
 * @type {{starter: string, highest: string, medium: string}}
 */
export const PLANS = {
  free: "FREE",
  starter: "BASIC",
  medium: "STANDARD",
  highest: "PREMIUM",
};

export const PLAN_NAMES = {
  [PLANS.free]: "Free",
  [PLANS.starter]: "Solo",
  [PLANS.medium]: "Small business",
  [PLANS.highest]: "Professional",
};

export const QUOTAS = {
  domains: "domains_limit",
  team: "team_limit",
  integrations: "integrations_limit",
  widgets: "widgets_limit",
  views: "views_limit",
  events: "events_limit",
  eventsMonthsAhead: "events_months_ahead",
};

export const QuotaLabelMapping = {
  [QUOTAS.team]: "Team member",
  [QUOTAS.widgets]: "Widget",
  [QUOTAS.integrations]: "Integration",
  [QUOTAS.domains]: "Website domain",
  [QUOTAS.views]: "Widget view",
  [QUOTAS.events]: "Syncing event",
  [QUOTAS.eventsMonthsAhead]: "Pulling events months ahead",
};

export const UsageFieldsMapping = {
  [QUOTAS.integrations]: "integrations",
  [QUOTAS.widgets]: "widgets",
  [QUOTAS.domains]: "domains",
  [QUOTAS.team]: "teams",
  [QUOTAS.views]: "widget_views",
};

export const UNBRANDED_YEARLY_PRICE = 50.0;
export const UNBRANDED_MONTHLY_PRICE = 5.0;

export const ShareIcon = isAppleDevice() ? "ios_share" : "share";

// mailchimp templates
export const MCT = {
  list: "list",
  compact: "compact",
  text: "text",
};
